import { render, staticRenderFns } from "./appsysuser-add-or-update.vue?vue&type=template&id=fc96bbe0&"
import script from "./appsysuser-add-or-update.vue?vue&type=script&lang=js&"
export * from "./appsysuser-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports